<template>
  <div>
    <div id="logo">
      <a v-if="linked" href="/"
        ><span class="allied">Allied</span><span class="crowds">Crowds</span></a
      >
      <div v-else style="font-size: 25px;">
        <span class="allied">Allied</span><span class="crowds">Crowds</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "logo",
  props: {
    linked: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
a {
  color: #2d3f50;
}

#logo .allied {
  font-weight: 500;
}

#logo .crowds {
  font-weight: 400;
}

#logo a {
  color: #2d3f50 !important;
  font-size: 25px;
}

#logo a:hover,
#logo a:active,
#logo a:focus {
  text-decoration: none;
  color: #c1c1c1 !important;
}
</style>



// WEBPACK FOOTER //
// src/elements/logo.vue